import { CSSProperties } from 'react'

import AvailabilityAlert from './AvailabilityAlert'

const DAYS_AFTER_START_DATE_THRESHOLD = 100
export const AVAILABILITY_SCORE_THRESHOLD = 20

type Props = {
  endDate: string
  fromDate?: string
  availabilityScore: number
  style?: CSSProperties
}

const ContextualAvailabilityAlert = ({
  availabilityScore,
  fromDate,
  endDate,
  style,
}: Props) => {
  const fromDateInstance = fromDate ? new Date(fromDate) : new Date()
  const endDateInstance = new Date(endDate)

  const diffTime = Math.abs(
    endDateInstance.getTime() - fromDateInstance.getTime()
  )

  const daysBetweenStartAndEndDate = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  const shouldDisplay =
    daysBetweenStartAndEndDate > 0 &&
    daysBetweenStartAndEndDate < DAYS_AFTER_START_DATE_THRESHOLD &&
    availabilityScore < AVAILABILITY_SCORE_THRESHOLD

  if (shouldDisplay !== true) {
    return null
  }

  return <AvailabilityAlert style={style} />
}

export default ContextualAvailabilityAlert
